import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({

  title: {
    fontWeight: 600,
    width: '100%',
    // paddingLeft: theme.spacing(1),
    // fontSize: 19,
    marginTop: '5px !important',
  },
  titlePrincipal: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 24,
  },
  subTitle: {
    width: '100%',
    // paddingLeft: theme.spacing(1),
    // fontSize: 19,
    marginBottom: '1% !important'
  },
  subTitle2: {
    width: '100%',
    // paddingLeft: theme.spacing(1),
    fontSize: 22,
    marginBottom: '3px !important'
  },
  subTitleCalculate: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 19,
    fontWeight: 'bold !important',
    marginBottom: '1% !important',
    textAlign: 'center',
  },
  TitleOffer: {
    width: '100% !important',
    // paddingLeft: theme.spacing(1),
    // fontSize: 19,
    marginTop: '4% !important',
    fontWeight: 'bold !important'
  },
  subTitleOffer: {
    // fontWeight: 600,
    width: '100%',
    // paddingLeft: theme.spacing(1),
    fontSize: 22,
    marginBottom: '4% !important',
  },

  // style de calculadora
  helpIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
  container: {
    display: 'grid !important',
    gridTemplateColumns: '20% 60% 20%',
    // gridAutoRows: '5vh !important',
    overflowY: 'hidden !important',
    // backgroundColor: '#FFFFFF !important'
  },
  centerColumn: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    // backgroundColor: '#f67',
    overflowX: 'none',
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'center !important',
    // backgroundColor: '#f2f',
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-end !important',
    justifyContent: 'center !important',
    overflowY: 'none',
    // backgroundColor: '#f2f',
  },
  titleSmall: {
    fontSize: 26,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  balanceText: {
    fontSize: 13,
    marginBottom: 10,
  },
  inputAmount: {
    width: '100% !important',
    marginTop: '2% !important',
  },
  inputAmount1: {
    width: '100% !important',
    marginTop: '2% !important',
    textAlign: 'center !important',
    border: 0,
    '&:hover': {
      border: 0,
    },
  },
  underline: {
    '&::hover': {
      border: 0
    },
    '&::after': {
      border: 0
    },
    '&::before': {
      border: 0,
    }
  },
  calculatesText: {
    fontSize: 16
  },
  containerResult: {
    display: 'grid !important',
    gridTemplateColumns: '70% 30%',
    ['@media only screen and (max-width: 812px)']: {
      // gridTemplateColumns: '5% 90% 5%',
      gridTemplateColumns: '50% 50%',
    },
    overflowY: 'none !important',
    // marginBottom: '5% !important'
  },
  leftColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'center !important',
  },
  rightColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-end !important',
    justifyContent: 'center !important',
    overflowY: 'none',
  },
  instructions: {
    marginTop: theme.spacing(2),
    textAlign: 'left',
    // font: 16,
    letterSpacing: '0.53px',
    color:  theme.palette.primary.color,
    opacity: 1
  },

  centerContent1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '85vh',
    width: '60%',
    position: 'relative',
    ['@media only screen and (max-width: 812px)']: {
      width: '90%',
      height: '85vh',
    }
  },

  stageTitle: {
    alignSelf: 'flex-start',
    fontSize: 24,
  },
  stageSubtitle: {
    alignSelf: 'flex-start',
    fontSize: 16,
  },
  stageText: {
    alignSelf: 'center !important',
    fontSize: 16,
  },
  stageDisplayTitle: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'rigth',
    marginBottom: 10,
  },
  sliderAmount: {
    jalignSelf: 'flex-center',
    paddingLeft: 20,
    paddingRight: 20,
  },
  stageDisplay: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20,
  },
  stageBodyHelp: {
    alignSelf: 'flex-start',
    fontSize: 16,
    marginBottom: 30,
    marginTop: 10,
  },
  stepsTitle: {
    fontSize: 16,
    width: '90% !important',
    paddingLeft: 20,
    paddingRight: 20,
    textAlign: 'left !important',
    ['@media only screen and (max-width: 812px)']: {
      fontSize: 16,
    },
  },
  rootList: {
    width: '100%',
    // height: '65vh !important',
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: theme.palette.background.paper,
    //outline: 'solid 1px green !important',
    overflowY: 'auto',
    //maxHeight: '70vh !important'
    ['@media only screen and (max-width: 812px)']: {
      height: '60vh !important',
    },
  },
  quotesBtn: {
    display: 'flex',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    alignSelf: 'center',
    color: '#FFFFFF',
    //  width: "1px !important",
    // // height: "30px",
    // fontSize: 16,
    // alignSelf: 'center',
    // marginTop: 10,
    // borderRadius: '50%',
  },
  pc12: {
    padding: '12px !important',
  },
  wc100: {
    width: '100% !important',
  },
  avatarInfo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  closeHelpView: {
    fontSize: 16,
    alignSelf: 'flex-end',
    marginBottom: '10px'
  },



  details: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column'
  },

  approved: {
    color: theme.palette.error.main,
    fontWeight: 'bold'
  },

  rejected: {
    color: theme.palette.success.main,
    fontWeight: 'bold'
  },

  waiting: {
    color: theme.palette.warning.main,
    fontWeight: 'bold'
  },

  noDoc: {
    color: theme.palette.secondary.contrastText,
    fontWeight: 'bold'
  },
  inputAmountAabilityPay: {
    // width: '100% !important',
    // marginTop: '2% !important',
    color: '#2D907B !important',
    fontSize: '30px',
  },
  continueBtn: {
    width: '100%',
    alignSelf: 'center !important',
    marginTop: '20px',
  },
  continueBtnDisabled: {
    width: '100%',
    alignSelf: 'center !important',
    marginTop: '20px',
    cursor: 'not-allowed !important',
    pointerEvents: 'none !important'
  },
  containerCapacidadPago: {
    width: '100% !important',
    backgroundColor: theme.palette.secondary.light,
  },
  buttonWidths: {
    width: '100% !important'
  },
  marginGral: {
    marginLeft: '0.5em',
    marginRight: '0.5em',
  }

}))
